/** Public CVE record URL for a CVE id. */
export function cveOrgUrl(cveId: string): string {
  return `https://www.cve.org/CVERecord?id=${cveId}`;
}
